// extracted by mini-css-extract-plugin
module.exports = {"className":"textPromoTitleL_className__neGLJ"};